import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import TargetingFilterItem from "../items/TargetingFilterItem.vue";
import ListSection from "../sections/ListSection.vue";
export default {
  name: "TargetingFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    TargetingFilterItem,
    ListSection
  },
  emits: ["clear", "discard", "restoreSearch", "select", "selectOnly", "deselect", "selectAll", "apply", "search", "hidden", "closeDropdown"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    }
  }
};